import { useState, useEffect, useContext } from "react";
import { Box, Fade, List, ListItem } from "@mui/material";
import { Link } from "react-router-dom";

import PageRoutes from "../Config/PageRoutes";
import MenuContext from "../store/menu-context";
import classes from "../Style/Menu.scss";
import ScientificReport from "../Components/ScientificReport";
import SideBarLineSvg from "./SideBarLineSvg";
import Logo from "./Logo";

const Menu = (props) => {
  const ctx = useContext(MenuContext);

  const handleSecondaryMenuClick = (index, id) => {
    ctx.updateContext(index, false);
  };

  // Casper: Which chapter is active: 1, 2, or 3?
  // Default is Chapter One (1), unless path matches "Chapter Two" or "Chapter Three"
  const [key, setKey] = useState(() => {
    if (props.path.indexOf(PageRoutes.CHAPTER_THREE) > -1) return 3;
    if (props.path.indexOf(PageRoutes.CHAPTER_TWO) > -1) return 2;
    return 1;
  });

  // On click of each chapter item
  const setSideBar = (activeKey) => {
    if (key === activeKey) return;
    setKey(activeKey);
  };

  // Sync with the URL path changing
  const path = props.path;
  useEffect(() => {
    if (path.indexOf(PageRoutes.CHAPTER_THREE) > -1) {
      setKey(3);
    } else if (path.indexOf(PageRoutes.CHAPTER_TWO) > -1) {
      setKey(2);
    } else {
      // default to chapter one
      setKey(1);
    }
  }, [path]);

  return (
    <Box className="menuWrapper">
      {/* <Link to={PageRoutes.ROOT}>Home</Link> */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        marginLeft="15px"
        marginBottom="1rem"
      >
        <Link to={PageRoutes.CHAPTER_ONE}>
          <Box
            sx={{
              display: "flex",
            }}
            onClick={() => setSideBar(1)}
          >
            <Logo />
          </Box>
        </Link>
      </Box>

      <Box alignItems="center" justifyContent="center">
        {<ScientificReport />}
      </Box>

      <Box className="innerMenu">
        <ul>
          {/* CHAPTER ONE */}
          <li>
            <Link to={PageRoutes.CHAPTER_ONE}>
              <Box sx={{ display: "flex" }}>

                <Box
                  onClick={() => setSideBar(1)}
                  className={key === 1 ? "menuItem active" : "menuItem"}
                >
                  <Box marginLeft="12px">
                    <SideBarLineSvg />
                  </Box>

                  <span>CHAPTER ONE</span>

                  <h3 className={key === 1 ? "" : "underline"}>
                    EU-coordinated multiannual control programme
                  </h3>
                </Box>
              </Box>
            </Link>
          </li>

          {/* CHAPTER TWO */}
          <li>
            <Link to={PageRoutes.CHAPTER_TWO}>
              <Box sx={{ display: "flex" }}>
                <Box></Box>

                <Box
                  onClick={() => setSideBar(2)}
                  className={key === 2 ? "menuItem active" : "menuItem"}
                >
                  <Box marginLeft="12px">
                    <SideBarLineSvg />
                  </Box>

                  <span>CHAPTER TWO</span>

                  <h3 className={key === 2 ? "" : "underline"}>
                    Multiannual national <br />
                    control programme
                  </h3>
                </Box>
              </Box>
            </Link>
          </li>

          {/* CHAPTER THREE */}
          <li>
            <Link to={PageRoutes.CHAPTER_THREE}>
              <Box sx={{ display: "flex" }}>
                <Box></Box>

                <Box
                  onClick={() => setSideBar(3)}
                  className={key === 3 ? "menuItem active" : "menuItem"}
                >
                  <Box marginLeft="12px">
                    <SideBarLineSvg />
                  </Box>

                  <span>CHAPTER THREE</span>

                  <h3 className={key === 3 ? "" : "underline"}>
                    Increased Import Control <br />
                    Programme
                  </h3>
                </Box>
              </Box>
            </Link>
          </li>

          {/* SLIDER HIGHLIGHT BAR */}
          <li
            className={
              key === 1
                ? "slide slide-ch1"
                : key === 2
                ? "slide slide-ch2"
                : "slide slide-ch3"
            }
          ></li>
        </ul>

        {/*
        <Fade in={props.path === PageRoutes.CHAPTER_TWO}>
          <List className='secondaryMenu'>
            <ListItem>
              <Box sx={{ display: 'flex', color: 'red !important' }}>
                <Box className='secondaryActiveWrapper'>
                  <Box
                    className={
                      ctx.index === 0
                        ? 'secondaryActiveWrapperInner secondaryActiveWrapperInnerActive'
                        : 'secondaryActiveWrapperInner'
                    }
                  ></Box>
                </Box>
                <Link onClick={handleSecondaryMenuClick.bind(this, 0)} to='#'>
                  Section I: Geospatial
                </Link>
              </Box>
            </ListItem>

            <ListItem>
              <Box sx={{ display: 'flex' }}>
                <Box className='secondaryActiveWrapper'>
                  <Box
                    className={
                      ctx.index === 1
                        ? 'secondaryActiveWrapperInner secondaryActiveWrapperInnerActive'
                        : 'secondaryActiveWrapperInner'
                    }
                  ></Box>
                </Box>
                <Link onClick={handleSecondaryMenuClick.bind(this, 1)} to='#'>
                  Section II: Residue level
                </Link>
              </Box>
            </ListItem>

            <ListItem>
              <Box sx={{ display: 'flex' }}>
                <Box className='secondaryActiveWrapper'>
                  <Box
                    className={
                      ctx.index === 2
                        ? 'secondaryActiveWrapperInner secondaryActiveWrapperInnerActive'
                        : 'secondaryActiveWrapperInner'
                    }
                  ></Box>
                </Box>
                <Link onClick={handleSecondaryMenuClick.bind(this, 2)} to='#'>
                  Section III: Food product groups
                </Link>
              </Box>
            </ListItem>
          </List>
        </Fade>
        */}
      </Box>
    </Box>
  );
};

export default Menu;
